<template>
  <div>
    <!-- v-footer -->
    <v-footer style="background-color: #141414" class="py-5 d-none d-sm-block pt-16 pb-12">
      <v-container style="padding: 0 !important">
        <v-row>

          <v-col cols="6" md="3">
           <div class="d-flex mb-3"><v-img src="/images/logo.webp" max-width="150"></v-img></div>
           <p class="text-subtitle-2 white--text"> We provide a variety of quality food (breakfast, meals, dinner) veg & non-veg food in trains for travelers across India.</p>
           <p class="mb-1 text-subtitle-2 white--text"> DL 55 | DL Block Sector II | Bidhannagar Kolkata | West Bengal | 700091 | INDIA   support@trainway.co.in | +91 88099-52644 </p>
           <p class="mb-1 text-subtitle-2 white--text"> Monday - Sunday ( 8:00 AM to 11:00 PM ) </p>

           <h3 class="text-h5 font-weight-bold text-subtitle-2 white--text mb-3">follow us on social media</h3>
            <div class="d-flex">
              <a href="https://www.facebook.com/profile.php?id=61550849225493/" class="mr-2" target="__blank" aria-label="facebook"><v-img src="/images/fb.png" max-height="30"  max-width="30" ></v-img ></a>
              <a href="https://www.instagram.com/trainwaay/" class="mr-2" target="__blank" aria-label="instagram"><v-img src="/images/instagram.png" max-height="30" max-width="30" ></v-img ></a>
              <a href="https://in.pinterest.com/trainway/" class="mr-2" target="__blank" aria-label="pinterest"><v-img  src="/images/pt.png"  max-height="30"  max-width="30" ></v-img></a>
              <a href="https://www.youtube.com/@trainwaay/" class="mr-2" target="__blank" aria-label="youtube"><v-img  src="/images/youtube.png"  max-height="30"  max-width="30"></v-img ></a>
              <a href="https://www.in.linkdin.com/@trainway/" class="mr-2" target="__blank" aria-label="linkdin"><v-img  src="/images/linkdin.png"  max-height="30"  max-width="30"></v-img ></a>
              <a href="https://www.x.com/@trainway/" class="mr-2" target="__blank" aria-label="X"><v-img  src="/images/tw.webp"  max-height="30"  max-width="30"></v-img ></a>
            </div>
            <p> </p>
            <h3 class="text-h5 font-weight-bold text-subtitle-2 white--text mb-3">Download App now</h3>
            <div class="d-flex">
              <a href="https://play.google.com/store/apps/details?id=com.trainway.trainway_final/" class="mr-2" target="__blank" aria-label="playstore"><v-img src="/images/gplay.webp" max-height="60"  max-width="80" ></v-img ></a>
              <a href="https://play.google.com/store/apps/details?id=com.trainway.trainway_final/" class="mr-2" target="__blank" aria-label="istore"><v-img src="/images/appstore.webp" max-height="60"  max-width="80" ></v-img ></a>
              </div>
            </v-col>

          <v-col cols="6" md="2">
            <p class="text-h6 white--text">COMPANY</p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/about-us" >About Us</router-link ></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/blogs" >Blogs</router-link ></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/contact-us" >Contact Us</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/disclaimer" >Disclaimer</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/faqs">FAQs</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/quality-assurance">Quality Assurance</router-link ></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/privacy-policy">Privacy Policy</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link  class="text-decoration-none text-subtitle-2 white--text" to="/cancellation-policy" >Refund & Cancellation Policy</router-link> </p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/sitemap" >Sitemap</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/terms-and-condition" >Terms & Conditions</router-link></p>

          </v-col>

          <v-col cols="6" md="2">
            <p class="text-h6 white--text">SERVICES </p>
            <p class="mb-2 text-subtitle-2 white--text">
              <router-link class="text-decoration-none text-subtitle-2 white--text" to="/food-on-train">Food on Train</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/irctc-food-booking">IRCTC Food Booking</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/group-order">Group Food Order in Train</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/khana-order-in-train">Khana Order in Train</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/food-delivery-in-train">Food Delivery in Train</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/jain-food-order">Jain Food order in Train</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/irctc-food-order">IRCTC food order</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/irctc-ecatering">IRCTC e-Catering Services </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/railway-food-delivery">Railway Food Delivery </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/order-food-in-train-on-whatsapp">Food Order on WhatsApp </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/food-in-train">Order Food in Train</router-link></p>

          </v-col>

            <v-col cols="6" md="2">
            <p class="text-h6 white--text">BECOME A PARTNER</p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/restaurant-signup">Vendor Registration</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/group-order">Tour Operator Order</router-link></p>
          </v-col>
            <v-col cols="6" md="3">
            <p class="text-h6 white--text">INDIAN RAILWAY SERVICES</p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/book-train-tickets">Book train Ticket </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text" to="/check-pnr-status">Check PNR Status </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/check-coach-position">Coach Position </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/fare-calculator">Fare Calculater </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"   to="/train-running-status">Spot Train Running</router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/station-details">Station Details </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/seat-availability">Seat Availability </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/train-time-table">Train Time Table </router-link></p>
            <p class="mb-2 text-subtitle-2 white--text">
            <router-link class="text-decoration-none text-subtitle-2 white--text"  to="/train-between-stations">Train between Sations </router-link></p>

          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <v-sheet class="d-none d-sm-block" style="background-color: #05445E">
      <v-container>
        <v-row>
          <v-col cols="12">
            <p class="text-center mb-2 text-subtitle-2 white--text">
              Copyright © 2023-2025 | trainway.in All Rights Reserved & Managed by :-
              <a href="https://www.trainway.in" class="text-decoration-none warning--text">DBAPORT TECHNOLOGY PVT LTD. </a>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <!-- v-footer -->
  </div>
</template>

<script>
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBJNVQEIUoRTs5kwTqFRtut_egZbPcPWWA",
  authDomain: "trainway-e2ea6.firebaseapp.com",
  projectId: "trainway-e2ea6",
  storageBucket: "trainway-e2ea6.appspot.com",
  messagingSenderId: "627116762081",
  appId: "1:627116762081:web:c053c830a463678197a8a0",
  measurementId: "G-PPPFF6R1PJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);
// receive
onMessage(messaging, (payload) => {
  console.log(payload);
  if (Notification.permission == "granted") {
    var notification = new Notification(payload.notification.title, {
      body: payload.notification.body,
    });
    // notification.onclick = function () {
    //   window.open("http://stackoverflow.com/a/13328397/1269037");
    // };
  }
});

export default {};
</script>


